import React, { } from 'react';
import { withTransaction } from '@elastic/apm-rum-react';
import { RoutePaths } from 'routes/RoutePaths';

export default withTransaction('RedirectServicesPage', 'component')(() => {
    const fullUrl = `${window.location.origin}${RoutePaths.Home.url()}`;
    return <div className="container-xxxl">
        <h1 className="display-3 pb-4">Your bookmarked URL is not valid anymore</h1>
        Please update your bookmark with <a href={RoutePaths.Home.url()}>{fullUrl}</a>
    </div>;
}) as React.FC;